export const cancel_2 = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 1L1 13" stroke="#25282B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1 1L13 13" stroke="#25282B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
